"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const css_1 = require("@emotion/css");
const preact_1 = require("preact");
const hooks_1 = require("preact/hooks");
const getSmallAvatar = (avatar) => {
    var _a, _b;
    if (!avatar)
        return '';
    const ext = (_b = (_a = avatar === null || avatar === void 0 ? void 0 : avatar.split('.')) === null || _a === void 0 ? void 0 : _a.pop()) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    return avatar.replace(`.${ext}`, `/80h.${ext}`);
};
const avatarCss = (0, css_1.css) `
    object-fit: cover;
    width: 32px;
    height: 32px;
    margin-right: 8px;
`;
const Avatar = ({ user, className = '' }) => {
    const defaultAvatarId = (0, hooks_1.useRef)(Math.floor(Math.random() * 5) + 1);
    const url = user.avatar_url
        ? getSmallAvatar(user.avatar_url)
        : `https://media.giphy.com/avatars/default${defaultAvatarId.current}.gif`;
    return (0, preact_1.h)("img", { src: url, className: (0, css_1.cx)(avatarCss, className) });
};
exports.default = Avatar;
//# sourceMappingURL=avatar.js.map